import { CheckoutMode } from '@/hooks/useCheckoutMode';

import { getBaseURL } from '@/utils/environment';
import { ChainHash } from '@/utils/models';

export const PAGE_DESCRIPTION = 'View the full trade details and order routing diagram on Matcha';

type SharePageQuery = {
  mode: CheckoutMode;
  funderAddress?: string;
};

export const getSharePageURL = (chainId: number, txHash: string, query?: SharePageQuery) => {
  const url = `${getBaseURL()}/tx/${chainId}/${txHash}`;
  if (!query) return url;
  const searchParams = new URLSearchParams({
    mode: query.mode,
    ...(query.funderAddress ? { funderAddress: query.funderAddress } : {}),
  });
  return `${url}?${searchParams.toString()}`;
};

export const shareTxOnX = (chainId: number, txHash: ChainHash, sharePageURL?: string) => {
  const encodedShareText = encodeURIComponent(PAGE_DESCRIPTION);
  const encodedSharePageURL = encodeURIComponent(sharePageURL ?? getSharePageURL(chainId, txHash));
  window.open(
    `https://x.com/intent/tweet?text=${encodedShareText}%0A%0A${encodedSharePageURL}`,
    '_blank',
  );
};

export const shareTxOnFarcaster = (chainId: number, txHash: ChainHash, sharePageURL?: string) => {
  const encodedShareText = encodeURIComponent(PAGE_DESCRIPTION);
  const encodedSharePageURL = encodeURIComponent(sharePageURL ?? getSharePageURL(chainId, txHash));
  window.open(
    `https://farcaster.xyz/~/compose?text=${encodedShareText}&embeds[]=${encodedSharePageURL}`,
    '_blank',
  );
};

export const copyTxLinkInClipboard = (
  chainId: number,
  txHash: ChainHash,
  sharePageURL?: string,
) => {
  navigator.clipboard.writeText(sharePageURL ?? getSharePageURL(chainId, txHash));
};
